export const getRequiredFieldsForStep = (stepId, steps, componentMap, checkoutPageState) => {
  const stepConfig = steps.find((step) => step.id === stepId);

  if (!stepConfig || !stepConfig.components) {
    return [];
  }

  const allRequiredFields = stepConfig.components.flatMap((componentName) => {
    const Component = componentMap[componentName];

    if (Component && typeof Component.validationFields === 'function') {
      const validationConfig = Component.validationFields(checkoutPageState);
      // All keys in validationFields are considered required fields
      return Object.keys(validationConfig);
    }
    return [];
  });

  return allRequiredFields;
};

export const areAllRequiredFieldsFilled = (
  requiredFields,
  watchedFieldValues,
) => requiredFields.every((fieldName, index) => {
  const value = watchedFieldValues[index];
  return value !== undefined && value !== null && value !== '';
});

export const hasValidationErrors = (requiredFields, formErrors) => requiredFields.some((
  fieldName,
) => {
  const fieldPath = fieldName.split('.');

  const errorObj = fieldPath.reduce((currentObj, pathSegment) => {
    if (currentObj && currentObj[pathSegment]) {
      return currentObj[pathSegment];
    }
    return null;
  }, formErrors);

  return errorObj && (errorObj.message || errorObj.type);
});

export const shouldEnableNextButton = (requiredFields, watchedFieldValues, formErrors) => {
  if (requiredFields.length === 0) {
    return true;
  }

  const allFieldsFilled = areAllRequiredFieldsFilled(requiredFields, watchedFieldValues);
  const hasErrors = hasValidationErrors(requiredFields, formErrors);

  return allFieldsFilled && !hasErrors;
};
